<template>
  <div v-loading="loading">
    <div class="flex flex-wrap justify-between">
      <div class="w-full lg:w-1/2 group-options-select">
        <div class="flex gap-4 justify-between">
          <div
            :style="{ width: '40px', height: '40px' }"
            class="bg-white lg:bg-gray-600 rounded-lg text-center cursor-pointer hover:shadow-sm"
            :class="{ 'shadow-sm': sortList }"
            @click="sortList = !sortList"
          >
            <img
              :style="{ 'margin-top': '10px', 'margin-left': '10px' }"
              class=""
              src="@/assets/images/icons/filter.svg"
              alt="filter icon"
            />
          </div>

          <div
            :style="{ height: '40px' }"
            class="table__search-input-wrapper mr-0 lg:mr-6"
          >
            <span class="pr-2 opacity-50">
              <search-icon />
            </span>

            <input
              type="text"
              class="table__search-input"
              placeholder="Search..."
              v-model="query"
            />

            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
        </div>
      </div>

      <base-button
        v-if="$_isAdmin"
        class="w-full lg:w-1/5"
        @click="$router.push({ name: 'NewTerminalToTerminalRoute' })"
        text="New Route"
      />
    </div>

    <!-- mobile screens -->
    <div
      v-for="route in paginatedList"
      :key="route.id"
      class="lg:hidden grid grid-cols-2 p-4 bg-white rounded-2xl mt-3"
    >
      <div>
        <p :style="{ color: '#979797' }" class="flex gap-2 text-xs font-semibold">
          <LocationIcon class="mt-1 mr-1" />
          ROUTE NAME
        </p>
        <p class="ml-4 text-xs">
          {{
            route.routeName
          }}
        </p>
      </div>

      <div>
        <div class="flex justify-between gap-2">
          <div
            class="rounded-lg px-3 py-1 text-xs text-center"
            :style="{
              height: '24px',
              width: '85px',
              'background-color': route.isPrimary ? '#09B78A1A' : '#FCC2101A',
              color: route.isPrimary ? '#09B78A' : '#FCC210',
            }"
          >
            {{ route.isPrimary ? "Primary" : "Secondary" }}
          </div>
          
          <el-dropdown v-if="$_isAdmin">
            <button>
              <vertical-ellipsis />
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <button
                  class="flex items-center"
                >
                  <div
                    class="cursor-pointer"
                    @click="viewRoute(data.item.id)"
                  >
                    <p>View & Edit</p>
                  </div>
                </button>
              </el-dropdown-item>

              <el-dropdown-item
              >

                    <div
                      class="cursor-pointer"
                      @click="showDeleteModal(data.item.id)"
                    >
                      <p>Delete</p>
                    </div>

              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="mt-3">
        <p :style="{ color: '#979797' }" class="flex gap-2 text-xs font-semibold">
          <LocationIcon class="mt-1 mr-1" />
          ROUTE TYPE
        </p>
        <p class="ml-4 text-xs">
          <span v-if="route.isInterstate">Inter-State</span>
          <span v-if="route.isIntrastate">Intra-State</span>
          <span v-if="route.isInternational">International</span>
        </p>
      </div>

      <div class="mt-3">
        <p :style="{ color: '#979797' }" class="flex gap-2 text-xs font-semibold">
          <LocationIcon class="mt-1 mr-1" />
          MEDIUM
        </p>
        <p class="ml-4 text-xs">
          {{ route.shippingMethod }}
        </p>
      </div>

      <div class="mt-3">
        <p :style="{ color: '#979797' }" class="flex gap-2 text-xs font-semibold">
          <LocationIcon class="mt-1 mr-1" />
          START/TERMINATE
        </p>
        <p class="ml-4 text-xs" v-if="route.isInterstate">
          {{ route.cities ? parseCities(route.cities[0]).start : "N/A" }}-{{
            route.cities ? parseCities(route.cities[0]).terminal : "N/A"
          }}
        </p>
        <p v-if="route.isIntrastate" class="ml-4 text-xs">
          {{ route.takeOff ? route.takeOff.name : "N/A" }}-{{
            route.arrival ? route.arrival.name : "N/A"
          }}
        </p>
      </div>

      <div class="mt-3">
        <p :style="{ color: '#979797' }" class="flex gap-2 text-xs font-semibold">
          <LocationIcon class="mt-1 mr-1" />
          DATE CREATED
        </p>
        <p class="ml-4 text-xs">
          {{ formatDate(route.createdAt) }}
        </p>
      </div>
    </div>
    <!--  -->

    <!-- large screen -->
    <div class="table-wrapper" id="table-wrapper">
      <b-table
        class="hidden lg:block"
        :items="paginatedList"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        responsive="sm"
      >
        <template #head(action)="">
          <span @click="isTableFilter = !isTableFilter" class="text-info">
            <img src="@/assets/images/icons/options-icon.png" alt=""
          /></span>
          <div v-if="isTableFilter">
            <table-filter
              :removedFields="removedFields"
              :fields="fields"
              @remove-field="removeField($event)"
              @add-field="addField($event)"
            />
          </div>
        </template>
        <template #cell(routeName)="data">
          <span>{{ data.item.routeName }}</span>
          <!-- <span v-if="data.item.isIntrastate"
            >{{ data.item.takeOff ? data.item.takeOff.name : "N/A" }} -
            {{ data.item.arrival ? data.item.arrival.name : "N/A" }}</span
          > -->
        </template>
        <template #cell(routes)="data">
          <span class="primary" v-if="data.item.isPrimary">Primary</span>
          <span v-else class="secondary">Secondary</span>
        </template>
        <template #cell(routeType)="data">
          <span v-if="data.item.isInterstate">Inter-State</span>
          <span v-if="data.item.isIntrastate">Intra-State</span>
          <span v-if="data.item.isInternational">International</span>
        </template>
        <template #cell(startTerminate)="data">
          <span v-if="data.item.isInterstate">
            {{ data.item.takeOff ? data.item.takeOff.locationName : "N/A" }}-{{
              data.item.arrival ? data.item.arrival.locationName : "N/A"
            }}
          </span>
          <span v-if="data.item.isIntrastate">
            {{ data.item.takeOff ? data.item.takeOff.locationName : "N/A" }}-{{
              data.item.arrival ? data.item.arrival.locationName : "N/A"
            }}
          </span>
        </template>
        <template #cell(created)="data">
          <span>{{ formatDate(data.item.createdAt) }}</span>
        </template>
        <template #cell(sst)="data">
          <span>{{ formatDate(data.item.createdAt) }}</span>
        </template>
        <template #cell(routeId)="data">
          <span>{{ formatDate(data.item.createdAt) }}</span>
        </template>
        <template #cell(expressDelivery)="data">
          <span>{{ formatDate(data.item.schedule) }}</span>
        </template>
        <template #cell(action)="data">
          <!-- <span @click="showActionOptions(data.item.id)">
            <vertical-ellipsis />
          </span> -->
          <el-dropdown v-if="$_isAdmin">
            <button>
              <vertical-ellipsis />
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <button
                  class="flex items-center"
                >
                  <div
                    class="cursor-pointer"
                    @click="viewRoute(data.item.id)"
                  >
                    <p>View & Edit</p>
                  </div>
                </button>
              </el-dropdown-item>

              <el-dropdown-item
              >

                    <div
                      class="cursor-pointer"
                      @click="showDeleteModal(data.item.id)"
                    >
                      <p>Delete</p>
                    </div>

              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </b-table>

      <div v-if="!loading && paginatedList.length == 0" class="mt-5" >
        <div class="flex flex-col justify-center items-center gap-4">
          <empty-route-icon />
  
          <p>No Route to display.</p>
  
          <div
            v-if="$_isAdmin"
            class="flex gap-2 text-primary-yellow text-center text-sm font-bold cursor-pointer"
            @click="$router.push({ name: 'NewTerminalToTerminalRoute' })"
          >
            <span>
              <svg
                width="23"
                height="23"
                viewBox="0 0 23 23"
                fill="#FCC210"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.5 22.3672C5.42487 22.3672 0.5 17.4423 0.5 11.3672C0.5 5.29206 5.42487 0.367188 11.5 0.367188C17.5751 0.367188 22.5 5.29206 22.5 11.3672C22.5 17.4423 17.5751 22.3672 11.5 22.3672ZM11.5 20.3672C16.4706 20.3672 20.5 16.3378 20.5 11.3672C20.5 6.39662 16.4706 2.36719 11.5 2.36719C6.52944 2.36719 2.5 6.39662 2.5 11.3672C2.5 16.3378 6.52944 20.3672 11.5 20.3672ZM16.5 10.3672H12.5V6.36719H10.5V10.3672H6.5V12.3672H10.5V16.3672H12.5V12.3672H16.5V10.3672Z"
                  fill="#FCC210"
                />
              </svg>
            </span>
            Start Adding Route
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <pagination
      :total="totalRoutes"
      :pageNumber="pageNumber"
      @pageNumber="setNumDisplayLocation"
      @pageSize="pageSize"
    />

    <delete-modal
      :showModal="isDeleteModal"
      :itemToDelete="itemToDelete"
      :deletingItem="deletingRoute"
      @close-modal="isDeleteModal = false"
      @delete-item="deleteRoute"
    />
  </div>
</template>

<script>
import pagination from "../../../../../UI/pagination.vue";
import TableFilter from "./TableFilter";
import LocationIcon from "@/components/UI/svgs/LocationIcon.vue";
// import ActionDropdown from "./ActionDropdown";
export default {
  components: {
    pagination,
    TableFilter,
    LocationIcon,
  },
  data() {
    return {
      fields: [
        {
          key: "routeName",
          label: "Route Name",
        },
        {
          key: "routes",
          label: "Routes",
          sortable: true,
        },
        {
          key: "routeType",
          label: "Route Type",
          sortable: true,
        },
        {
          key: "shippingMethod",
          label: "Medium",
          sortable: true,
        },
        {
          key: "startTerminate",
          label: "Start Terminate",
        },
        {
          key: "created",
          label: "Date Created",
          sortable: true,
        },

        {
          key: "action",
          label: "",
        },
      ],

      removedFields: [
        {
          key: "sst",
          label: "SST",
        },
        {
          key: "routeId",
          label: "Route ID",
        },
        {
          key: "expressDelivery",
          label: "Express Delivery",
          sortable: true,
        },
      ],
      sortBy: "age",
      sortDesc: false,
      selectedRowId: null,
      routes: [],
      isTableFilter: false,
      loading: true,
      isDeleteModal: false,
      itemToDelete: "Route",
      deletingRoute: false,
      selectedRouteId: "",
      query: "",
      sortList: false,
      totalRoutes: 1,
      routesPerPage: 10,
      pageNumber: 1,
    };
  },
  computed: {
    filteredRoutes() {
      return this.filterArray(this.routes, this.query);
    },
    lists() {
      return this.sortList
        ? this.filteredRoutes
            .map((l) => l)
            .sort((a, b) => {
              var x = a.routeName.toLowerCase();
              var y = b.routeName.toLowerCase();
              return x < y ? -1 : x > y ? 1 : 0;
            })
        : this.filteredRoutes;
    },
    startRange() {
      return (this.pageNumber - 1) * Number(this.routesPerPage);
    },
    endRange() {
      return this.pageNumber * Number(this.routesPerPage);
    },
    paginatedList() {
      return this.lists.filter(
        (item, index) => index >= this.startRange && index < this.endRange
      );
    },
    setparams() {
      return {
        terminalType: "terminal-to-terminal",
        pageSize: this.routesPerPage,
        pageNum: this.pageNumber,
      };
    },
  },
  mounted() {
    this.getAllRoutes(this.setparams);
  },
  watch: {
    setparams() {
      this.loading = true;
      this.getAllRoutes(this.setparams);
    },
  },

  methods: {
    parseCities(city) {
      return JSON.parse(city);
    },
    removeField(data) {
      // let field =   this.fields.find(field=>field.key===data)
      let index = this.fields.indexOf(data);

      this.fields.splice(index, 1);
      this.removedFields.push(data);
      this.isTableFilter = false;
    },
    addField(data) {
      let index = this.removedFields.indexOf(data);
      this.removedFields.splice(index, 1);
      this.fields.splice(this.fields.length - 1, 0, data);
      this.isTableFilter = false;
    },
    settoOrigin() {
      // this.routesPerPage = this.routes.length;
      // this.pageNumber = 1;
    },
    pageSize(val) {
      this.routesPerPage = val;
    },
    setNumDisplayLocation(val) {
      this.pageNumber = val;
    },
    async getAllRoutes(params) {
      try {
        let response = await this.$_getAllRoutes(params);
        this.loading = false;
        this.routes = response.data.data.shippingServices;
        this.totalRoutes = response.data?.data?.totalCount;
        console.log(response.data.data);
      } catch (error) {
        // this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    async deleteRoute() {
      this.deletingRoute = true;
      try {
        let response = await this.$_deleteRoute(this.selectedRouteId);
        this.logResponse(response);
        this.generateToast("Route successfully Deleted", "success");
        this.getAllRoutes(this.setparams);
        this.deletingRoute = false;
        this.isDeleteModal = false;
      } catch (error) {
        this.handleError(error);
        this.deletingRoute = false;
      }
    },
    showDeleteModal(routeId) {
      this.selectedRouteId = routeId;
      this.isDeleteModal = true;
    },
    createRoute(routeType) {
      if (routeType == "Primary Route") {
        this.$store.dispatch("saveRouteType", "Primary Route");
        this.$router.push({ name: "NewRoute" });
      } else {
        this.$store.dispatch("saveRouteType", "Secondary Route");
        this.$router.push({ name: "NewRoute" });
      }
    },
    viewRoute(routeId) {
      localStorage.setItem("routeId", routeId);
      this.$router.push({ name: "EditTerminalToTerminal" });
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>

<style scoped>
.primary {
  background: #09b78a1a;
  color: #09b78a;
  padding: 0.5rem;
  border-radius: 2px;
}

.secondary {
  background: #fcc2101a;
  color: #fcc210;
  padding: 0.5rem;
  border-radius: 2px;
}

.table-wrapper {
  margin: 3rem 0;
}

.table-header {
  display: flex;
  justify-content: flex-end;
}

.table__btn {
  padding: 0.45rem 0.85rem;
  color: #ffffff;
  font-size: 0.85rem;
  border-radius: 3px;
}

.table__search-input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f0f2f1;
  height: 2.25rem;
  width: 30vw;
  border-radius: 15px;
  padding: 0 1rem;
}

.table__search-input {
  background: transparent;
  color: #343633;
  font-size: 0.9rem;
  width: 100%;
  height: 100%;
}

.table__search-input:focus {
  outline: none;
}

.table__search-input::placeholder {
  color: #343633;
  font-size: 0.9rem;
}

.custom-table {
  margin: 2rem 0;
  width: 100%;
}

.custom-table th {
  color: #060e18;
  font-weight: 600;
}

.custom-table th,
td {
  padding: 1rem;
  font-size: 0.9rem;
}

.custom-table td {
  color: #343633;
}

.table__action-btn {
  position: relative;
  padding: 0;
}

.table__action-options {
  position: absolute;
  width: 8rem;
  padding: 0.5rem 0;
  right: 2rem;
  background: #ffffff;
  z-index: 999;
  border-radius: 3px;
  box-shadow: 0px 0px 12px #dee0e7;
}

.table__action-option {
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
}

.table__action-option:hover {
  background: #fce4da;
}

.table__action-btn span {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .table__search-input-wrapper {
    width: 100%;
  }
  .table__btn-wrapper {
    width: 100%;
  }
  .button {
    width: 100%;
    margin-bottom: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  #table-wrapper {
    margin: 2rem 0 0;
    overflow-x: auto;
  }
  .table-wrapper,
  .table-wrapper .custom-table {
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
  }
  /* width */
  .table-wrapper::-webkit-scrollbar {
    cursor: pointer;
    width: 5px;
    height: 8px;
  }
  /* Track */
  .table-wrapper::-webkit-scrollbar-track {
    background: #c4c4c4;
  }
  /* Handle */
  .table-wrapper::-webkit-scrollbar-thumb {
    background: #fab427;
    width: 5px;
    border-radius: 20px;
  }
}
</style>
